import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { Container, Row, Col, Label, Input } from "reactstrap";
import { useSelector } from "react-redux";

import { staticData } from "managers/staticDataManager";
import { loadOldDocuments } from "views/callApi";
import { useNavigateUrl } from "managers/utilManager";

const OldDocumentsFilter = (params) => {
  const history = useHistory();

  const state = useSelector((state) => state);
  const { channel } = useSelector((state) => state.staticData);
  const { language } = useSelector((state) => state.account);

  const [filterData, setFilterData] = useState(null);
  const [issuersData, setIssuersData] = useState([]);

  React.useEffect(() => {
    let filter = prepareFilter(params.data);
    setFilterData(filter);
  }, [params.data]);

  const navigateUrl = useNavigateUrl();
  React.useEffect(() => {
    if (!filterData) return;

    if (filterData?.isPushRequest) {
      if (filterData?.issuerId) {
        history.push(
          navigateUrl(`/old-documents/${filterData?.issuerId}`),
          filterData
        );
      } else {
        history.push(`/old-documents`, filterData);
      }
      return;
    }

    loadOldDocuments(
      state,
      filterData,
      handleOldDocumentsData,
      params.setIsBusy,
      params.alertRef
    );
  }, [filterData]);

  React.useEffect(() => {
    if (
      !filterData ||
      !state?.account?.language?.languageId ||
      filterData.languageId === state?.account?.language?.languageId
    ) {
      return;
    }

    setFilterData({
      ...filterData,
      languageId: state?.account?.language?.languageId,
    });
  }, [state?.account?.language?.languageId]);

  const handleOldDocumentsData = (data) => {
    if (!data) {
      setIssuersData([]);
      return;
    }

    data.issuers.unshift({ issuerId: 0 });
    setIssuersData(data.issuers);
    params.setDocumentsData(data.reports);
  };

  const prepareFilter = (data) => {
    let result = {
      issuerId: data?.issuerId ?? filterData?.issuerId ?? parseInt(0),
      languageId: language?.languageId,
      channelId: channel?.channelId,
      isPushRequest: false,
    };

    return result;
  };

  const getIssuers = () => {
    return issuersData.sort((a, b) => {
      if (a.issuerId === 0) return -1;
      if (b.issuerId === 0) return 1;
      return a.issuer.localeCompare(b.issuer);
    });
  };

  return (
    <Container>
      <Row>
        <Col
          sm="3"
          md="3"
          className="mt-5"
          style={{ display: "inline-flex", alignItems: "center" }}
        />
        <Col
          sm="6"
          md="6"
          className="mt-5"
          style={{ display: "inline-flex", alignItems: "center" }}
        >
          <Label key="labelIssuerId" id="labelIssuerId" for="formIssuerId">
            {staticData.loadTerms(useSelector, "VW_COMMON_ISSUER")}
          </Label>
          <Input
            key="formIssuerId"
            id="formIssuerId"
            name="issuerId"
            type="select"
            disabled={params.isBusy}
            className="form-control"
            value={filterData?.issuerId}
            onChange={(e) => {
              let tmpIssuerId =
                e.target.value === "0" ? undefined : parseInt(e.target.value);
              setFilterData({
                ...filterData,
                page: 1,
                issuerId: tmpIssuerId,
                isPushRequest: true,
              });
            }}
          >
            {getIssuers().map((issuer) => (
              <option
                key={issuer?.issuerId ? issuer.issuerId : 0}
                data-key={issuer?.issuerId}
                value={issuer?.issuerId}
              >
                {issuer.issuer}
              </option>
            ))}
          </Input>
        </Col>
        <Col
          sm="3"
          md="3"
          className="mt-5"
          style={{ display: "inline-flex", alignItems: "center" }}
        />
      </Row>
    </Container>
  );
};

export default OldDocumentsFilter;
